<script lang="ts">
  import { onMount } from "svelte";
  import { apiFetch } from "$lib/api";
  import PlanPicker, { type Plan } from "$lib/components/plan-picker.svelte";

  let plans = $state<Plan[]>([]);
  let loading = $state(true);
  let error = $state<string | null>(null);

  onMount(async () => {
    try {
      plans = await apiFetch<Plan[]>("/api/public/plans");
    } catch (e) {
      error = e instanceof Error ? e.message : String(e);
    } finally {
      loading = false;
    }
  });

  function goToSignup() {
    window.location.href = "/signup";
  }
</script>

<div class="min-h-screen bg-background text-foreground px-4 py-10 sm:px-6 lg:px-8">
  <div class="mx-auto w-full max-w-5xl space-y-8">
    <div class="flex flex-col items-center gap-2 text-center">
      <img src="/DT-logo.jpg" alt="DataTurk.ai" class="size-12 rounded-lg object-contain" />
      <span class="font-semibold text-xl tracking-wide" style="font-family: 'Sora', sans-serif;">DataTurk.ai</span>
    </div>

    <div class="space-y-2 text-center">
      <h1 class="text-3xl font-bold tracking-tight">Plans &amp; pricing</h1>
      <p class="text-base text-muted-foreground">Pick a plan to get started.</p>
    </div>

    {#if loading}
      <p class="text-center text-sm text-muted-foreground">Loading plans…</p>
    {:else if error}
      <p class="text-center text-sm text-destructive">{error}</p>
    {:else if plans.length === 0}
      <p class="text-center text-sm text-muted-foreground">No plans are available right now.</p>
    {:else}
      <PlanPicker {plans} mode="public" onSelect={goToSignup} />
    {/if}
  </div>
</div>
